module.exports = __webpack_public_path__ + "static/media/notification.8a372eae.png";


//////////////////
// WEBPACK FOOTER
// ./src/icons/symptoms/notification.png
// module id = 412
// module chunks = 0